<template>
  <div>
    <el-dialog
      id="editDialog"
      :title="orderId ? '修改调拨单' : '新增调拨单'"
      :visible="true"
      @close="close(false)"
      width="1000px"
    >
      <el-form
        :model="headInfo"
        label-position="right"
        label-width="110px"
        ref="editOrderFormRef"
        :rules="{
          orderDate: this.$ruleUtil.simple({
            fieldName: '单据日期',
            handleType: '选择',
            required: true,
          }),
          totalQuantity: this.$ruleUtil.number(
            '所选商品数量',
            this.quantityMinLimit,
            1000
          ),
        }"
        v-if="headInfo"
      >
        <el-form-item label="单号" v-if="headInfo.id">
          <span v-fmtype="headInfo.orderNo ? null : 'info'">{{
            headInfo.orderNo || "草稿"
          }}</span>
          <el-tag
            class="fm-ml-5"
            :type="
              $jsTool.getOrderApprovalStatusType(
                headInfo.orderApprovalStatusEnum
              )
            "
            >{{ headInfo.orderApprovalStatusEnum.Desc }}</el-tag
          >
        </el-form-item>
        <el-form-item label="单据日期" prop="orderDate">
          <el-date-picker
            v-model="headInfo.orderDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择单据日期"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="所选商品" prop="totalQuantity">
          <div class="fm-flex">
            <p
              v-fmtype="'success'"
              v-if="headInfo.totalQuantity && headInfo.totalQuantity > 0"
            >
              {{ "共 " + headInfo.totalQuantity + " 件商品" }}
            </p>
            <span v-fmtype="'error'" v-else>未选择商品</span>
            <el-button
              class="fm-ml-15"
              type="primary"
              plain
              size="mini"
              icon="el-icon-plus"
              @click="showSelectCommodityDialog"
              >选择商品</el-button
            >
          </div>
        </el-form-item>

        <el-table
          :data="itemList || []"
          stripe
          :row-key="
            (row) => {
              return row.itemNo + row.commoditySpecId;
            }
          "
          max-height="500px"
          style="width: 100%"
        >
          <el-table-column
            label="商品图片"
            width="100"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <CommodityImage
                :commodity="scope.row.commodity"
                v-if="scope.row.saleSuitId"
              ></CommodityImage>
              <CommodityImage
                :commodity="scope.row.commodity"
                :commoditySpec="scope.row.commoditySpec"
                v-else
              ></CommodityImage>
            </template>
          </el-table-column>
          <el-table-column
            prop="commodity.name"
            label="商品信息"
            min-width="200"
            align="left"
            header-align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div style="line-height: 1.3em">
                <span style="font-size: 1.1em">{{
                  scope.row.commodity.name
                }}</span
                ><br />
                {{ "规格：" + scope.row.commoditySpec.specName }}<br />
                {{ "分类：" + scope.row.commodity.commodityCategory.name
                }}<br />
                {{ "颜色：" + scope.row.commodity.color }}<br />
                {{ "单位：" + scope.row.commodity.unit }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemQuantity"
            label="调拨数量"
            width="400"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-table
                :data="scope.row.outWareHouseAddNewPojoList || []"
                stripe
                border
                style="width: 100%"
                :row-key="
                  (row) => {
                    return row.itemNo + row.wareHouseId;
                  }
                "
              >
                <el-table-column
                  prop="name"
                  label="仓库"
                  min-width="180"
                  align="center"
                  header-align="center"
                >
                  <template slot-scope="innerScope">
                    {{
                      innerScope.row.wareHouse
                        ? innerScope.row.wareHouse.name
                        : ""
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="数量"
                  min-width="180"
                  align="center"
                  header-align="center"
                >
                  <template slot-scope="innerScope">
                    <CommodityQuantityInputBox
                      :key="
                        'orderWareHouseItemQuantityInputNumber' +
                        innerScope.$index +
                        itemQuantityKey
                      "
                      v-model="innerScope.row.itemQuantity"
                      size="small"
                      @change="
                        (e) => {
                          changeOrderWareHouseItemQuantity(
                            scope.$index,
                            innerScope.$index,
                            innerScope.row,
                            e
                          );
                        }
                      "
                    ></CommodityQuantityInputBox>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemQuantity"
            label="调拨数量"
            width="100"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.itemQuantity }}
            </template>
          </el-table-column>
          <el-table-column
            prop="inWareHouseId"
            label="调入仓库"
            width="150"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <template
                v-if="
                  canSelectWareHouseListBySpec(scope.row.commoditySpec).length >
                  0
                "
              >
                <el-select
                  :value="scope.row.inWareHouseId"
                  placeholder="请选择仓库"
                  @change="
                    (value) =>
                      selectWareHousePopupConfirmTransferIn(value, scope.$index)
                  "
                >
                  <el-option
                    v-for="(item, index) in canSelectWareHouseListBySpec(
                      scope.row.commoditySpec
                    )"
                    :key="item.wareHouseId + index"
                    :label="item.label"
                    :value="item.wareHouseId"
                  >
                    <span style="float: left">{{ item.label }}</span>
                    <span
                      style="float: right; color: #8492a6; font-size: 13px"
                      >{{ item.desc }}</span
                    >
                  </el-option>
                </el-select>
              </template>
              <div style="text-align: left" v-else>
                <span>{{ scope.row.wareHouse.name }}</span>
              </div>
              <div style="text-align: left">
                <span v-if="scope.row.wareHouse">
                  {{ "虚拟库存 " + scope.row.fictitiousQuantity }}
                </span>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-form-item label="备注" prop="remark" class="fm-mt-10">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            maxlength="200"
            show-word-limit
            v-model="headInfo.remark"
            style="width: 400px"
            placeholder="请输入备注信息"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close(false)">取 消</el-button>
        <el-button type="primary" @click="edit(false)"> 保存至草稿 </el-button>
        <el-popconfirm
          icon="el-icon-info"
          :icon-color="$jsTool.getColor('warning')"
          :title="
            orderConfig.needApproval
              ? '是否将单据提交审批？'
              : '当前单据提交后将自动审批通过，请确认单据信息无误，是否继续提交？'
          "
          @confirm="edit(true)"
        >
          <el-button slot="reference" type="success" @click.native.stop>
            保存并提交
          </el-button>
        </el-popconfirm>
      </div>
    </el-dialog>

    <CommoditySelectDialog
      :show="commoditySelectDialogShow"
      from="CommodityTransferOrder"
      :selectList="itemList"
      @selectCommodity="
        (itemList) => {
          selectCommodity(itemList, true);
        }
      "
      @close="commoditySelectDialogShow = false"
      v-if="commoditySelectDialogShow"
    ></CommoditySelectDialog>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebCommodityTransferOrderEditDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: String,
      default: null,
    },
  },
  watch: {
    show: {
      handler(newVal) {
        if (newVal) {
          setTimeout(async () => {
            Object.assign(this.$data, this.$options.data());
            this.$nextTick(() => {
              this.$refs.editOrderFormRef.clearValidate();
            });
            await this.getCanSelectWareHouseList();
            this.initOrderData();
            this.getOrderConfig();
            this.quantityMinLimit = this.$jsTool.getTenantDecimalLength();
            if (this.orderId) {
              setTimeout(async () => {
                await this.getOrderInfo();
                this.$nextTick(() => {
                  this.$refs.editOrderFormRef.clearValidate();
                });
              }, 100);
            }
          }, 100);
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      orderConfig: {
        needApproval: true,
      },

      orderDatePickerShow: false,

      editItemPopupShow: false,
      editItem: {},

      id: null,
      headInfo: {
        orderApprovalStatusEnum: {},
        orderDate: null,
        totalQuantity: 0,
        remark: "",
      },
      itemList: [],

      commoditySelectDialogShow: false,

      selectWareHousePopupShow: false,
      selectWareHousePopupIndex: -1,
      wareHouseList: [],

      canSelectWareHouseList: [],
      selectWareHousePopupShowTransferIn: false,
      wareHouseListTransferIn: [],

      itemQuantityKey: "null",

      quantityMinLimit: 0.001,
    };
  },

  mounted() {},

  methods: {
    async getCanSelectWareHouseList(args) {
      let res = await this.$api.wareHouse_findListForSelect(args);
      if (res && res.success) {
        this.canSelectWareHouseList = res.data;
      }
    },

    canSelectWareHouseListBySpec(commoditySpec) {
      let res = commoditySpec.commoditySpecWareHouseList.map((d) => {
        return {
          label: d.wareHouse.name,
          wareHouse: d.wareHouse,
          wareHouseId: d.wareHouseId,
          fictitiousQuantity: d.fictitiousQuantity,
          availableQuantity: d.availableQuantity,
          desc: "虚拟库存 " + d.fictitiousQuantity,
        };
      });
      let oldIdList = res.map((d) => d.wareHouseId);
      if (
        this.canSelectWareHouseList &&
        this.canSelectWareHouseList.length > 0
      ) {
        res = res.concat(
          this.canSelectWareHouseList
            .filter((d) => oldIdList.indexOf(d.id) < 0)
            .map((d) => {
              return {
                label: d.name,
                wareHouse: d,
                wareHouseId: d.id,
                fictitiousQuantity: 0,
                availableQuantity: 0,
                desc: "该仓库中没有此规格",
              };
            })
        );
      }
      return res;
    },

    // 调拨单选择调入仓库
    selectWareHousePopupConfirmTransferIn(item, index) {
      if (!item) {
        return;
      }
      let data = this.canSelectWareHouseListBySpec(
        this.itemList[index].commoditySpec
      ).filter((d) => d.wareHouseId && d.wareHouseId == item)[0];
      this.itemList[index].inWareHouseId = data.wareHouseId;
      this.itemList[index].inWareHouse = data.wareHouse;
    },

    initOrderData() {
      this.headInfo.orderDate = this.$moment(new Date()).format("yyyy-MM-DD");
    },
    async getOrderConfig() {
      let res = await this.$api.tenantPersonalConfig_findByCodeIn([
        "Order:CommodityTransferOrder:NeedApproval",
      ]);
      if (res && res.success) {
        let needApprovalIndex = res.data.findIndex(
          (d) => d.code == "Order:CommodityTransferOrder:NeedApproval"
        );
        if (
          needApprovalIndex > -1 &&
          res.data[needApprovalIndex].value == "false"
        ) {
          this.orderConfig.needApproval = false;
        }
      }
    },
    changeOrderWareHouseItemQuantity(
      index,
      subIndex,
      row,
      orderWareHouseValue
    ) {
      if (orderWareHouseValue < 0) {
        row.itemQuantity = 0;
      }
      if (orderWareHouseValue <= 0) {
        if (this.itemList[index].outWareHouseAddNewPojoList.length != 1) {
          this.itemList[index].outWareHouseAddNewPojoList.splice(subIndex, 1);
        }
      } else {
        this.itemList[index].outWareHouseAddNewPojoList.splice(
          subIndex,
          1,
          row
        );
      }
      let itemQuantity = this.$jsTool.sumQuantity(
        this.itemList[index].outWareHouseAddNewPojoList.map(
          (d) => d.itemQuantity
        )
      );
      this.changeItemQuantity(index, this.itemList[index], itemQuantity);
    },

    // 选择商品相关
    showSelectCommodityDialog() {
      this.commoditySelectDialogShow = true;
    },
    async selectCommodity(list) {
      list.forEach((item, index) => {
        item.itemNo = index + 1; // 索引从 0 开始，所以 itemNo 从 1 开始
      });
      this.itemList = list;
      this.headInfo.totalQuantity = Number(
        this.$jsTool.sumQuantity(list.map((d) => d.itemQuantity))
      );
      this.$forceUpdate();
      this.commoditySelectDialogShow = false;
    },
    changeItemQuantity(index, row, value) {
      let that = this;
      if (value < 0) {
        row.itemQuantity = 0;
      }
      if (value <= 0) {
        this.$confirm("是否移除所选商品?", "操作提醒", {
          confirmButtonText: "移除",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
        })
          .then(() => {
            this.itemList[index].outWareHouseAddNewPojoList.splice(0, 1);
            that.itemList.splice(index, 1);
            this.itemQuantityKey = Math.random();
            that.selectCommodity(that.itemList || []);
          })
          .catch(() => {
            this.itemList[index].outWareHouseAddNewPojoList[0].itemQuantity =
              that.quantityMinLimit;
            row.itemQuantity = that.quantityMinLimit;
            // this.changeItemQuantity(index, row, 1);
            this.itemQuantityKey = Math.random();
            that.selectCommodity(that.itemList || []);
          });
      } else {
        row = {
          ...row,
          itemQuantity: value,
        };
        that.itemList.splice(index, 1, row);
        that.selectCommodity(that.itemList || []);
      }
    },

    async getOrderInfo(args) {
      let res = await this.$api.commodityTransferOrder_findVoById(
        this.orderId,
        {
          showLoading: true,
          loadingParam: {
            target: "#editDialog > *",
            lock: true,
          },
          ...args,
        }
      );
      if (res && res.success) {
        this.headInfo = {
          ...res.data.head,
        };

        let commodityIdList = res.data.itemList.map((d) => d.commodityId);
        let findCommodityVoRes = await this.$api.commodity_findVoByIdIn(
          commodityIdList,
          {
            showLoading: true,
            loadingParam: {
              target: "#editDialog > *",
              lock: true,
            },
          }
        );
        let commodityVoList = [];
        if (findCommodityVoRes && findCommodityVoRes.success) {
          commodityVoList = findCommodityVoRes.data;
        }

        this.itemList = res.data.itemList.map((d) => {
          let item = d;
          let commodityVo = commodityVoList.filter(
            (f) => f.commodity.id == item.commodityId
          )[0];
          item.commodity = commodityVo.commodity;
          item.commoditySpec = commodityVo.commoditySpecList.filter(
            (f) => f.id == item.commoditySpecId
          )[0];
          item.outWareHouseAddNewPojoList = item.outWareHouseList.map((f) => {
            let specWareHouse =
              item.commoditySpec.commoditySpecWareHouseList.filter(
                (g) => g.wareHouseId == f.wareHouseId
              );
            return {
              itemNo: f.itemNo,
              wareHouse: f.wareHouse,
              wareHouseId: f.wareHouseId,
              fictitiousQuantity: specWareHouse.fictitiousQuantity || 0,
              availableQuantity: specWareHouse.fictitiousQuantity || 0,
              itemQuantity: f.itemQuantity,
            };
          });
          return item;
        });

        this.$nextTick(() => {
          setTimeout(() => {
            if (
              this.hasSettledAmount ||
              this.hasOtherExpenseAmount ||
              this.hasOtherCostAmount
            ) {
              this.$forceUpdate();
            }
          }, 200);
        });
      }
    },

    edit(submit) {
      this.$refs.editOrderFormRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        let requestRes = this.headInfo.id
          ? submit
            ? await this.$api.commodityTransferOrder_updateAndSubmit(
                {
                  headUpdatePojo: {
                    ...this.headInfo,
                  },
                  itemAddNewPojoList: this.itemList,
                },
                {
                  showLoading: true,
                  loadingParam: {
                    target: "#editDialog > *",
                    lock: true,
                    text: "修改中...",
                  },
                }
              )
            : await this.$api.commodityTransferOrder_update(
                {
                  headUpdatePojo: {
                    ...this.headInfo,
                  },
                  itemAddNewPojoList: this.itemList,
                },
                {
                  showLoading: true,
                  loadingParam: {
                    target: "#editDialog > *",
                    lock: true,
                    text: "修改中...",
                  },
                }
              )
          : submit
          ? await this.$api.commodityTransferOrder_saveIntoDraftAndSubmit(
              {
                headAddNewPojo: {
                  ...this.headInfo,
                },
                itemAddNewPojoList: this.itemList,
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "新增中...",
                },
              }
            )
          : await this.$api.commodityTransferOrder_saveIntoDraft(
              {
                headAddNewPojo: {
                  ...this.headInfo,
                },
                itemAddNewPojoList: this.itemList,
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "新增中...",
                },
              }
            );
        if (requestRes && requestRes.success) {
          this.close(true);
        }
      });
    },
    close(flush) {
      this.$emit("close", flush);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/order/CommodityTransferOrderEditDialog.vue